//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";

export default {
    name: "QfPSizing",
    data() {
        return {
            standard: 0,
            localValue: false,
            desktop: { value: 1, auto: true },
            tablet: { value: 1, auto: true },
            phone: { value: 1, auto: true }
        };
    },
    computed: {
        ...mapState("components", ["activeComponent", "properties"]),
        local() {
            return this.activeComponent && this.properties[this.activeComponent] ? this.properties[this.activeComponent].__generics
                : { sizeDesktop: 0, sizeTablet: 0, sizePhone: 0 };
        }
    },
    watch: {
        "local.sizeDesktop": {
            handler(val) {
                this.desktop = val ? { value: val, auto: false } : { value: 1, auto: true };
                const isRichText = this.properties[this.activeComponent].__component === "ctrl-rich-text";
                if (this.desktop.auto && isRichText) {
                    this.desktop.value = 12;
                }
            },
            immediate: true
        },
        "local.sizeTablet": {
            handler(val) {
                this.tablet = val ? { value: val, auto: false } : { value: 1, auto: true };
                const isRichText = this.properties[this.activeComponent].__component === "ctrl-rich-text";
                if (this.tablet.auto && isRichText) {
                    this.tablet.value = 12;
                }
            },
            immediate: true
        },
        "local.sizePhone": {
            handler(val) {
                this.phone = val ? { value: val, auto: false } : { value: 12, auto: true };
            },
            immediate: true
        }
    },
    methods: {
        desktopAuto(val) {
            this.local.sizeDesktop = val ? 0 : this.desktop.value;
        },
        tabletAuto(val) {
            this.local.sizeTablet = val ? 0 : this.tablet.value;
        },
        phoneAuto(val) {
            this.local.sizePhone = val ? 0 : this.phone.value;
        },
        desktopChange(val) {
            this.local.sizeDesktop = val;
        },
        tabletChange(val) {
            this.local.sizeTablet = val;
        },
        phoneChange(val) {
            this.local.sizePhone = val;
        }
    }
};
